const formatDispatchDuration = (minutes: number): string => {
  if (!minutes) return '0 minutes';

  if (minutes < 60) {
    return `${minutes} minutes`;
  }

  const hours = minutes / 60;
  const isWholeNumber = hours % 1 === 0;
  const formattedHours = isWholeNumber ? hours.toString() : hours.toFixed(1);

  return `${formattedHours} ${hours === 1 ? 'hour' : 'hours'}`;
};

export default formatDispatchDuration;
